import React, {Component} from 'react'
import trans from "trans"

import {
    GridCell,
    Spinner,
    Paginator,
    Select,
} from "@bdfx/mergado-ui-kit"

import {Option} from "@bdfx/mergado-ui-kit/lib/components/Form/Select";

import {superadminGetTemplatePreviews} from "app/helpers/api";
import {URL} from "app/config/api-config";
import {FiltersGrid, StyledProductGrid} from "./product-images";
import {Template} from "app/types/model-types";
import { TemplateBadges } from 'template-list/template-badges';

interface Props {
    selectedProjectId: number
}

interface State {
    templates: TemplatePreviewsType
    recentFirst: boolean
    isLoading: boolean
}

export type TemplatePreviewsType = {
    totalCount: number
    templateData: TemplateDataType[]
    isRecentFirst: boolean
    page: number
    maxPage: number
    limit: number
}

export type TemplateDataType = {
    width: number
    height: number
    sizeName: number
    productsCount: number
    shapesCount: number
    template: Template
}

class Templates extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            templates: null,
            isLoading: false,
            recentFirst: true,
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            this.getTemplates(
                this.state.templates && this.state.templates.page ? this.state.templates.page : 1,
                this.state.templates && this.state.templates.limit ? this.state.templates.limit : DEFAULT_PAGE_LIMIT
            )
        }
    }

    getTemplates = (page : number, limit : number) => {
        const {recentFirst} = this.state
        const {selectedProjectId} = this.props

        superadminGetTemplatePreviews(selectedProjectId, page, limit, recentFirst)
            .then((response: any) => {
                this.setState({templates: response.data})
            })
            .catch(error => {
                console.error(error.response)
            })
            .finally(() => {
                this.setState({isLoading: false})
            })
    }

    componentDidMount() {
        this.getTemplates(1, DEFAULT_PAGE_LIMIT)
    }

    handlePageChange = (page) => {
        this.getTemplates(page, this.state.templates.limit ?? DEFAULT_PAGE_LIMIT)
    }

    render() {
        const {isLoading, templates} = this.state

        if (isLoading) {
            return <div>Getting products info <Spinner type={'bubbles'} /></div>
        }

        if (!templates || !templates.templateData) {
            return <div />
        }

        const productsPerPage : Option[] = [25, DEFAULT_PAGE_LIMIT, 100].map((o : number) => ({label: `${o}`, value: `${o}`}))

        return (
            <div>
                <h2>Templates ({templates.totalCount})</h2>

                <FiltersGrid>
                    <GridCell>
                        <Paginator
                            showFirstAndLast={true}
                            showPrevAndNext={true}
                            maxLinks={5}
                            labelFirst={`«« ${trans('first')}`}
                            labelPrevious={`« ${trans('previous')}`}
                            labelNext={`${trans('next')} »`}
                            labelLast={`${trans('last')} »»`}
                            currentPage={templates.page}
                            lastPage={templates.maxPage}
                            onPageChange={(page) => this.handlePageChange(page)}
                        />
                    </GridCell>
                    <GridCell>
                        <Select
                            options={productsPerPage}
                            value={`${templates.limit}`}
                            onChange={(limit) => {
                                this.getTemplates(1, limit)
                            }}
                        />
                    </GridCell>
                    <GridCell>

                    </GridCell>
                </FiltersGrid>

                <StyledProductGrid>
                    {templates.templateData.map(item => {
                        const template = item.template
                        return <GridCell key={template.id} className={'shadow-box'}>
                            <div className="project-id"><a href={`https://app.mergado.com/projects/${template.project_id}`} target="_blank">{template.project_id}</a></div>
                            <div className="template-date">created {template.created_at}</div>
                            <div className="template-date">updated {template.updated_at}</div>
                            <div className="template-id">
                                {template.name} ({template.id})
                                <span className="shapes-count">{item.shapesCount} shape(s)</span>, <span
                                className="products-count">{item.productsCount} product(s)</span>
                            </div>
                            <div className="template-image">
                                <a href={`${URL.laravelBase}reports/get-template-png/${template.id}`} target="_blank" title={`${template.name} (${template.id})`}>
                                    <img src={`${URL.laravelBase}reports/get-template-png/${template.id}`} className="shadow-box checker template-image" />
                                </a>
                            </div>
                            <div className={`template-is-active ${template.active ? 'active' : 'inactive' }`}>
                                {template.active ? 'active' : 'inactive'}
                                <TemplateBadges template={template} showIcons={true} showInline={false} />
                            </div>
                            <div className="template-size">{item.sizeName} [{item.width}x{item.height}]
                            </div>
                        </GridCell>
                    })}
                </StyledProductGrid>
            </div>
        )
    }
}

const DEFAULT_PAGE_LIMIT = 50

export default Templates